import { action, computed, observable, makeObservable } from "mobx";
import { NotificacaoDto } from "../modelo/Notificacao";

class NotificacaoStore {
    modalNotificacoesAberto = false;
    notificacoes: NotificacaoDto[] = [];

    constructor() {
        makeObservable(this, {
            modalNotificacoesAberto: observable,
            notificacoes: observable,
            temNotificacao: computed,
            limpar: action,
            fechar: action
        });
    }

    get temNotificacao() {
        return this.notificacoes.length > 0;
    }

    limpar = (id?: string) => {
        if (id?.length > 0) {
            this.notificacoes = this.notificacoes.filter(notificacao => notificacao.id !== id);
        } else {
            this.notificacoes = [];
        }
    };

    fechar = () => {
        this.modalNotificacoesAberto = false;
    };
}

export default new NotificacaoStore();